import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/girav.webp';
import screenshot_target from '../../../images/letterfunnel/stefanvandenberg.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Stefan van den Berg"
      firstname="Stefan"
      companyname="Girav"
      competition="Alan Red en Highleytall"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/stefanvandenberg.js